<!-- 人员活跃时段统计 -->
<template>
  <div class="active-person">
    <div id="periodChart" :style="{ width: '100%' }"></div>
    <div class="unit">{{ $t('Company') }}：<i class="unit_icon"></i>{{ $t('NumberOfPeople') }}/{{ $t('time') }}</div>
  </div>
</template>

<script>
import { attendStatistics } from '@/api/log'
import { formatDate } from '@/util/date'
import { mapGetters } from 'vuex'
export default {
  props: {
    currenNode: {
      type: Object,
    },
  },
  data() {
    return {
      lightbg: '',
      // 图标颜色数组
      echartInfo: {
        lineChart: '',
        colorStops: '',
        colorGra: '',
        colorOffset: '',
      },
      activeData: [],
    }
  },
  methods: {
    attendanceStatics() {
      let param = {
        ouId: this.currenNode.id,
        logDateBegin: formatDate(this.currenNode.startTime),
        logDateEnd: formatDate(this.currenNode.endTime),
      }
      attendStatistics(param).then(res => {
        if (res.state === 0) {
          if (res.value) {
            if (res.value.attendTimeNum) {
              this.activeData = res.value.attendTimeNum
              this.drawPeriodChart()
            }
          }
        }
      })
    },
    // 人员活跃表
    drawPeriodChart() {
      // 初始化echart
      this.$nextTick(() => {
        this.myEchartLine = this.$echarts.init(document.getElementById('periodChart'))
        // 绘制图表
        this.myEchartLine.setOption({
          xAxis: {
            type: 'category',
            data: ['0', '2', '4', '6', '8', '10', '12', '14', '16', '18', '20', '22', '24'],
            axisLabel: {
              show: true,
              textStyle: {
                color: this.lightbg, //更改坐标轴文字颜色
                fontSize: 12, //更改坐标轴文字大小
              },
            },
            axisLine: {
              lineStyle: {
                color: 'rbga(20, 53, 139, 0.5)', //更改坐标轴颜色
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,
              textStyle: {
                color: this.lightbg, //更改坐标轴文字颜色
                fontSize: 12, //更改坐标轴文字大小
              },
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              // 自定义网格线样式
              lineStyle: {
                type: 'solid',
                color: this.echartInfo.lineChart,
              },
            },
          },
          grid: {
            x: '3%', //距离左边
            x2: '0%', //距离右边
            y: '15%', // 上距离
            y2: '15%', // 下距离
            containLabel: true,
          },
          series: [
            {
              type: 'line',
              data: [
                this.activeData['00'] ? this.activeData['00'] : 0,
                this.activeData['02'] ? this.activeData['02'] : 0,
                this.activeData['04'] ? this.activeData['04'] : 0,
                this.activeData['06'] ? this.activeData['06'] : 0,
                this.activeData['08'] ? this.activeData['08'] : 0,
                this.activeData['10'] ? this.activeData['10'] : 0,
                this.activeData['12'] ? this.activeData['12'] : 0,
                this.activeData['14'] ? this.activeData['14'] : 0,
                this.activeData['16'] ? this.activeData['16'] : 0,
                this.activeData['18'] ? this.activeData['18'] : 0,
                this.activeData['20'] ? this.activeData['20'] : 0,
                this.activeData['22'] ? this.activeData['22'] : 0,
                this.activeData['24'] ? this.activeData['24'] : 0,
              ],
              smooth: true,
              symbol: 'none', // 去除小圆点
              areaStyle: {
                //填充区域样式
                normal: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: this.echartInfo.colorGra,
                      },
                      {
                        offset: 1,
                        color: this.echartInfo.colorOffset,
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
              },
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: this.echartInfo.colorStops,
                  },
                },
              },
            },
          ],
        })
      })
    },
    // 切换主题 图标的颜色要重新刷新
    getChartColor() {
      if (this.isDefaultTheme) {
        this.lightbg = '#333'
        this.echartInfo.lineChart = 'rgba(232, 236, 243, 1)'
        this.echartInfo.colorStops = '#1C75DD'
        this.echartInfo.colorGra = 'rgba(168, 202, 251, 0.5)'
        this.echartInfo.colorOffset = 'rgba(255, 255, 255, 1)'
      } else {
        this.lightbg = '#fff'
        this.echartInfo.lineChart = 'rgba(20, 53, 139, 0.7)'
        this.echartInfo.colorStops = '#FF2888'
        this.echartInfo.colorGra = 'rgba(255, 40, 136, 0.5)'
        this.echartInfo.colorOffset = 'rgba(255, 40, 136, 0.1)'
      }
      this.drawPeriodChart()
    },
  },
  watch: {
    isDefaultTheme: {
      immediate: true,
      handler() {
        this.getChartColor()
      },
    },
    'currenNode.startTime': {
      immediate: true,
      handler(val) {
        this.attendanceStatics()
      },
    },
    // 'currenNode.endTime': {
    //    immediate: true,
    //    handler(val) {
    //     this.attendanceStatics()
    //   }
    // },
    'currenNode.id': {
      immediate: true,
      handler(val) {
        this.attendanceStatics()
      },
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.active-person
  height calc(100% - 50px)
  position: relative
  #periodChart
    height 100%
  .test
    background: #ccc
    pointer-events: auto
.unit_icon
  width: 10px
  height: 10px
  border-radius: 50%
  display: inline-block
  margin-right 5px
  background: rgb(254, 40, 136)
</style>
